import { useIncentives } from 'src/payments/hooks/use-incentives/use-incentives';
import { useCashBackSurfacesConfig } from 'src/payments/hooks/use-cash-back-surfaces-config';
import type { CashBackSurfacesConfig } from 'src/payments/hooks/use-cash-back-surfaces-config/use-cash-back-surfaces-config';
import type { ValidIncentiveValue } from 'src/payments/hooks/shared/incentive-types';

export type CashBackSurfaceGate = {
  showCashBack: boolean;
  cashBackValue?: ValidIncentiveValue;
};

// Gates cash-back surfaces on canonical useIncentives().isCashBack precedence: when the
// dispensary signup discount wins, isCashBack is false and both outputs suppress, so the
// discount value is never exposed to these surfaces.
export function useCashBackSurfaceGate(surface: keyof CashBackSurfacesConfig): CashBackSurfaceGate {
  const surfacesConfig = useCashBackSurfacesConfig();
  const { isCashBack, incentiveValue } = useIncentives();

  const showCashBack = Boolean(surfacesConfig[surface] && isCashBack && incentiveValue !== undefined);

  return {
    showCashBack,
    cashBackValue: showCashBack ? incentiveValue : undefined,
  };
}
